import LabelCollection from './LabelCollection';

// Labels attached to at least one active, visible device.
// The endpoint is paginated ({ labels, hasMore }); fetch() pulls pages until the server reports no more.
class ActiveDeviceLabelCollection extends LabelCollection {
  get url() {
    return '/api/ui/lookups/activeDeviceLabels';
  }

  get jsonRoot() {
    return 'labels';
  }

  processData(response, fetchOptions) {
    // GET requests carry the offset in the query string; base processData keys off data.offset to append pages
    const offset = fetchOptions?.query?.offset;
    const appendOptions = offset ? { ...fetchOptions, data: { ...fetchOptions.data, offset } } : fetchOptions;
    const result = super.processData(response, appendOptions);
    this.hasMoreResults = !!response?.hasMore;
    return result;
  }

  async fetch(options = {}) {
    const firstPage = await super.fetch(options);

    while (this.hasMoreResults) {
      const previousSize = this.unfilteredSize;
      // eslint-disable-next-line no-await-in-loop
      await super.fetch({ ...options, pagedFetch: true, query: { ...options.query, offset: previousSize } });
      // guard against a server that returns no new rows while still reporting hasMore
      if (this.unfilteredSize <= previousSize) {
        this.hasMoreResults = false;
      }
    }

    return firstPage;
  }
}

export default ActiveDeviceLabelCollection;
